<template>
	<div class="unsupported">
		<div class="tit">미리보기를 제공하지 않는 파일입니다.</div>
		<div class="txt">압축파일, 디자인 파일, 파일 크기가 큰 파일 등은 미리 보기를 제공하지 않습니다. <br>화면 오른쪽 상단 <b></b>을 클릭하여, 파일 다운로드를 선택해 주세요.</div>
	</div>
</template>

<script>
export default {
	props: [
		'fileInfo'
	]
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/cowork/general/file/viewer/detail/ViewerBlock.vue